<template>
    <div>
        <b-sidebar id="sidebar-backdrop" :backdrop-variant="'dark'" backdrop shadow :visible="!!driverID" :right="true"
            no-header-close no-close-on-backdrop no-close-on-esc>
            <template #header="{ }" v-if="currentTeamMember">
                <div class="d-flex align-items-center w-100 justify-content-between">
                    <div class="d-flex align-items-center w-100 mr-2">
                        <div class="text-nowrap" v-if="currentTeamMember.user">
                            {{ currentTeamMember.user.first_name }} {{ currentTeamMember.user.last_name }}
                        </div>
                        <!-- <b-button
                            class="ml-5 export pe-none d-flex justify-content-center align-items-center w-100px h-40px"
                            :class="currentTeamMember.status
                                ? 'equipment'
                                : 'inactive-equipment'
                                " :variant="currentTeamMember.status ? 'primary' : 'secondary'">
                            <p class="mb-0">{{ currentTeamMember.status ? 'Active' : "Inactive" }}</p>
                        </b-button> -->
                    </div>
                    <b-dropdown id="dropdown-divider" text="text" class="load-dropdown-2 mt-0" v-if="allowUpdateDrivers">
                        <template slot="button-content">
                            <b-icon class="dots" icon="three-dots"></b-icon>
                        </template>
                        <b-dropdown-item-button class="mb-2" v-if="currentTeamMember.status
                            " @click="$bvModal.show('modal-password'); showPassword = false; password = ''">
                            <p class="text_secondary cursor-pointer mb-0 f-14">{{ $t('editTeamMember.setPassword') }}</p>
                        </b-dropdown-item-button>
                        <b-dropdown-item-button class="mb-2" v-if="currentTeamMember.status"
                            @click="$bvModal.show('send-invite-modal')">
                            <p class="text_secondary cursor-pointer mb-0 f-14">{{ $t('editTeamMember.sendInvite') }}</p>
                        </b-dropdown-item-button>
                        <b-dropdown-item-button class="mb-2" @click="$bvModal.show('qr-password-modal')">
                            <p class="text_secondary cursor-pointer mb-0 f-14">{{ $t('editTeamMember.qrCode') }}</p>
                        </b-dropdown-item-button>
                        <b-dropdown-item-button class="mb-2" @click="viewDriverMode()">
                            <p class="text_secondary cursor-pointer mb-0 f-14">{{ $t('editTeamMember.driverView') }}</p>
                        </b-dropdown-item-button>
                        <b-dropdown-item-button v-if="currentTeamMember.status" class="mb-2"
                            @click="showMemberModal = true">
                            <p class="text_secondary cursor-pointer mb-0 f-14">{{ $t('editTeamMember.deactivate') }}</p>
                        </b-dropdown-item-button>
                        <b-dropdown-item-button v-else class="mb-2" @click="showMemberModal = true">
                            <p class="text_secondary cursor-pointer mb-0 f-14">{{ $t('editTeamMember.activate') }}</p>
                        </b-dropdown-item-button>
                        <b-dropdown-item-button v-if="allowDeleteDriver" @click="showDeleteDriverModal = true">
                            <p class="text_secondary cursor-pointer mb-0 f-14">{{ $t('editTeamMember.deleteDriver') }}</p>
                        </b-dropdown-item-button>
                    </b-dropdown>
                </div>
            </template>
            <div class="body" v-if="currentTeamMember">
                <div class="sidebar-tabs">
                    <div class="bg-white rounded">
                        <v-tabs class="team-tabs mb-0" v-model="activeTab" show-arrows>
                            <v-tab key='info'>{{ $t('editTeamMember.infoTab') }}</v-tab>
                            <v-tab key='documents' v-if="allowViewDocDrivers">{{ $t('editTeamMember.documentsTab')
                            }}</v-tab>
                            <v-tab key='notes'>{{ $t('editTeamMember.notesTab') }}</v-tab>
                            <v-tab key='activity' v-if="showActivitySection">{{ $t('editTeamMember.activityTab') }}</v-tab>
                        </v-tabs>
                    </div>
                </div>
                <v-tabs-items v-model="activeTab">
                    <v-tab-item key='info'>
                        <hr class="mt-0" />
                        <div class="d-block text-center mt-4rem">
                            <b-row class="align-items-center px-4">
                                <b-col cols="12" class="w-100" v-if="requiredDocsRecords.length">
                                    <b-alert show variant="danger" class="f-14 text-left w-100">{{ requiredDocsMessage }}</b-alert>
                                </b-col>
                                <h3 class="f-18 font-weight-bold col-12 text-left">{{ $t('teamMemberShared.basic') }}</h3>
                                <b-col sm="12" class="mt-3" v-if="currentTeamMember.user">
                                    <b-form-group :label="$t('teamMemberShared.firstNameLabel')" class="text-left mb-0">
                                        <b-form-input v-model="currentTeamMember.user.first_name" type="text"
                                            :placeholder="$t('teamMemberShared.firstNamePlaceholder')" class="unit"
                                            :disabled="!allowUpdateDrivers" required></b-form-input>
                                        <p v-if="errors && errors.first_name
                                            " class="field-error">
                                            {{ errors.first_name[0] }}
                                        </p>
                                    </b-form-group>
                                </b-col>
                                <b-col sm="12" class="mt-3" v-if="currentTeamMember.user">
                                    <b-form-group :label="$t('teamMemberShared.lastNameLabel')" class="text-left mb-0">
                                        <b-form-input v-model="currentTeamMember.user.last_name" type="text"
                                            :placeholder="$t('teamMemberShared.lastNamePlaceholder')" class="unit"
                                            :disabled="!allowUpdateDrivers" required></b-form-input>
                                        <p v-if="errors && errors.last_name
                                            " class="field-error">
                                            {{ errors.last_name[0] }}
                                        </p>
                                    </b-form-group>
                                </b-col>
                                <b-col sm="12" class="mt-3">
                                    <b-form-group :label="$t('teamMemberShared.usernameLabel')" class="text-left mb-0">
                                        <b-form-input type="text" autocomplete="new-username"
                                            :placeholder="$t('teamMemberShared.usernamePlaceholder')"
                                            v-model="memberUsername" :disabled="!allowUpdateDrivers"
                                            class="unit"></b-form-input>
                                        <p v-if="errors && errors.username
                                            " class="field-error">
                                            {{ errors.username[0] }}
                                        </p>
                                    </b-form-group>
                                </b-col>
                                <b-col sm="12" class="text-left mt-3">
                                    <b-form-group :label="$t('editTeamMember.statusLabel')" class="text-left mb-0">
                                        <b-form-input type="text"
                                            :value="currentTeamMember.status ? $t('editTeamMember.statusActive') : $t('editTeamMember.statusInactive')"
                                            :placeholder="$t('editTeamMember.statusPlaceholder')" disabled></b-form-input>
                                    </b-form-group>
                                </b-col>
                                <b-col sm="12" class="mt-3" v-if="currentTeamMember.user">
                                    <b-form-group :label="$t('teamMemberShared.emailLabel')" class="text-left mb-0">
                                        <b-form-input v-model="currentTeamMember.user.email" :disabled="!allowUpdateDrivers"
                                            type="text" :placeholder="$t('teamMemberShared.emailPlaceholder')" class="unit"
                                            required></b-form-input>
                                        <p v-if="errors &&
                                            errors.email
                                            " class="field-error">
                                            {{ errors.email[0] }}
                                        </p>
                                    </b-form-group>
                                </b-col>
                                <b-col sm="12" class="mt-3">
                                    <b-form-group :label="$t('teamMemberShared.phoneLabel')"
                                        class="text-left position-relative mb-0">
                                        <b-input-group size="lg" class="w-100" prepend="+1">
                                            <b-form-input v-mask="phoneMask" class="f-14" v-model="driverPhoneNumber"
                                                :disabled="!allowUpdateDrivers"></b-form-input>
                                        </b-input-group>
                                        <p v-if="errors && errors.phone" class="field-error">
                                            {{ errors.phone[0] }}
                                        </p>
                                    </b-form-group>
                                </b-col>
                            </b-row>
                            <b-row class="px-4">
                                <b-col sm="12" class="mt-3">
                                    <b-form-group :label="$t('teamMemberShared.licenseLabel')" class="text-left mb-0">
                                        <b-form-input :disabled="!allowUpdateDrivers"
                                            v-model="currentTeamMember.license_number" type="text"
                                            :placeholder="$t('teamMemberShared.licensePlaceholder')" class="unit"
                                            required></b-form-input>
                                    </b-form-group>
                                </b-col>
                                <b-col sm="12" class="text-left mt-3" v-if="currentTeamMember.state">
                                    <label class="state">{{ $t('teamMemberShared.stateLabel') }}</label>
                                    <v-select class="f-12 h-40px" :options="states" :reduce="(option) => option.id"
                                        v-model="currentTeamMember.license_state.id" :disabled="!allowUpdateDrivers" />
                                </b-col>
                            </b-row>
                            <hr class="m-4" />
                            <b-row class="px-4">
                                <h3 class="f-18 font-weight-bold col-12 text-left">{{ $t('teamMemberShared.tagsHeading') }}
                                </h3>
                                <b-col md="12" class="mt-3">
                                    <v-select class="f-12" :options="allTags" multiple :reduce="(option) => option.id"
                                        v-model="existingTags" :disabled="!allowUpdateDrivers" />
                                </b-col>
                            </b-row>
                            <hr class="m-4" />
                            <b-row class="px-4">
                                <h3 class="f-18 font-weight-bold col-12 text-left">{{ $t('teamMemberShared.divisionHeading')
                                }}</h3>
                                <b-col sm="12" class="mt-3">
                                    <v-select class="f-12" :clearable="false" :options="allDivisions" v-model="divisionId"
                                        :reduce="(option) => option.id" />
                                </b-col>
                                <p v-if="errors && errors.division" class="field-error px-3">
                                    {{ errors.division[0] }}
                                </p>
                            </b-row>
                            <hr class="m-4" />
                            <b-row class="px-4">
                                <h3 class="f-18 font-weight-bold col-12 text-left">{{ $t('teamMemberShared.detailsHeading')
                                }}</h3>
                                <!-- <b-col sm="12" class="text-left select_arrow mt-3">
                                    <label>Type:</label>
                                    <b-form-select class="f-12" :disabled="$store.state.user.user.team_member.role !== 'Admin' &&
                                        $store.state.user.user.team_member.role !== 'Operations'" :options="[
        { value: null, text: '' },
        { value: 'Company', text: 'Company' },
        {
            value: 'Owner Operator',
            text: 'Owner Operator',
        },
    ]" v-model="currentTeamMember.driver_type"></b-form-select>
                                    <p v-if="errors && errors.driver_type" class="field-error mb-lg-3">
                                        {{ errors.driver_type[0] }}
                                    </p>
                                </b-col> -->
                                <b-col sm="12" class="mt-3">
                                    <b-form-group :label="$t('teamMemberShared.driverIdLabel')" class="text-left mb-0">
                                        <b-form-input :disabled="!allowUpdateDrivers"
                                            v-model="currentTeamMember.employee_id" type="text"
                                            :placeholder="$t('teamMemberShared.driverIdPlaceholder')" class="unit"
                                            required></b-form-input>
                                        <p v-if="errors && errors.employee_id" class="field-error">
                                            {{ errors.employee_id[0] }}
                                        </p>
                                    </b-form-group>
                                </b-col>
                                <!-- <b-col sm="12" class="mt-3">
                                    <b-form-group label="Driver Pin:" class="text-left mb-0">
                                        <b-form-input :disabled="$store.state.user.user.team_member.role !== 'Admin' &&
                                            $store.state.user.user.team_member.role !== 'Operations'"
                                            v-model="currentTeamMember.pin_code" type="text" placeholder="Enter Pin"
                                            class="unit" required></b-form-input>
                                        <p v-if="errors && errors.pin_code" class="field-error">
                                            {{ errors.pin_code[0] }}
                                        </p>
                                    </b-form-group>
                                </b-col> -->
                                <!-- <b-col sm="12" class="text-left select_arrow mt-3">
                                    <label>CDL:</label>
                                    <b-form-select class="f-12" :disabled="$store.state.user.user.team_member.role !== 'Admin' &&
                                        $store.state.user.user.team_member.role !== 'Operations'" :options="[
        {
            value: null,
            text: '',
        },
        {
            value: true,
            text: 'Yes',
        },
        {
            value: false,
            text: 'No',
        },
    ]" v-model="currentTeamMember.CDL"></b-form-select>
                                </b-col> -->
                                <b-col sm="12" class="text-left mt-3">
                                    <label for="dob-datepicker" class="state">{{ $t('teamMemberShared.dobLabel') }}</label>
                                    <date-picker v-model="currentTeamMember.dob" :formatter="momentFormat"
                                        :range-separator="' - '" @clear="currentTeamMember.dob = ''"
                                        :placeholder="$t('teamMemberShared.selectDate')" class="date-picker-custom"
                                        :teleport="'body'" :disabled="!allowUpdateDrivers"></date-picker>
                                    <p v-if="errors && errors.dob" class="field-error">
                                        {{ errors.dob[0] }}
                                    </p>
                                </b-col>
                                <b-col sm="12" class="text-left mt-3">
                                    <label for="active-datepicker" class="state">{{ $t('teamMemberShared.activeDateLabel')
                                    }}</label>
                                    <date-picker v-model="currentTeamMember.activate_date" :formatter="momentFormat"
                                        :range-separator="' - '" @clear="currentTeamMember.activate_date = ''"
                                        :placeholder="$t('teamMemberShared.selectDate')" class="date-picker-custom"
                                        :teleport="'body'" :disabled="!allowUpdateDrivers"></date-picker>
                                    <p v-if="errors && errors.activate_date" class="field-error">
                                        {{ errors.activate_date[0] }}
                                    </p>
                                </b-col>
                                <b-col sm="12" class="text-left mt-3">
                                    <label for="active-datepicker" class="state">{{ $t('teamMemberShared.inactiveDateLabel')
                                    }}</label>
                                    <date-picker v-model="currentTeamMember.inactive_date" :formatter="momentFormat"
                                        :range-separator="' - '" @clear="currentTeamMember.inactive_date = ''"
                                        :placeholder="$t('teamMemberShared.selectDate')" class="date-picker-custom"
                                        :teleport="'body'" :disabled="!allowUpdateDrivers"></date-picker>
                                    <p v-if="errors && errors.inactive_date" class="field-error">
                                        {{ errors.inactive_date[0] }}
                                    </p>
                                </b-col>
                            </b-row>
                            <hr class="m-4" v-if="driverCustomFields.length" />
                            <b-row class="px-4" v-if="driverCustomFields.length">
                                <h3 class="f-18 font-weight-bold col-12 text-left">{{
                                    $t('teamMemberShared.customFieldsHeading') }}</h3>
                                <b-col v-for="field in driverCustomFields" :key="field.id" sm="12" class="mt-3">
                                    <b-form-group v-if="field.field_type === 'text'" :label="`${field.name}:`"
                                        class="text-left mb-0">
                                        <b-form-input v-model="customFieldValues[field.id]" type="text"
                                            :placeholder="$t('teamMemberShared.enterPrefix', { name: field.name })"
                                            class="unit" :disabled="!allowUpdateDrivers"></b-form-input>
                                    </b-form-group>
                                    <b-form-group v-else-if="field.field_type === 'number'" :label="`${field.name}:`"
                                        class="text-left mb-0">
                                        <b-form-input v-model="customFieldValues[field.id]" type="number"
                                            :placeholder="$t('teamMemberShared.enterPrefix', { name: field.name })"
                                            class="unit" :disabled="!allowUpdateDrivers"></b-form-input>
                                    </b-form-group>
                                    <b-form-group v-else-if="field.field_type === 'date'" :label="`${field.name}:`"
                                        class="text-left mb-0">
                                        <b-form-input v-model="customFieldValues[field.id]" type="date"
                                            :placeholder="$t('teamMemberShared.enterPrefix', { name: field.name })"
                                            class="unit" :disabled="!allowUpdateDrivers"></b-form-input>
                                    </b-form-group>
                                    <div v-else-if="field.field_type === 'select'" class="text-left">
                                        <label class="state">{{ field.name }}:</label>
                                        <v-select class="f-12" :options="field.options" :disabled="!allowUpdateDrivers"
                                            v-model="customFieldValues[field.id]" />
                                    </div>
                                    <div v-else-if="field.field_type === 'multi_select'" class="text-left">
                                        <label class="state">{{ field.name }}:</label>
                                        <v-select class="f-12" :options="field.options" multiple
                                            :disabled="!allowUpdateDrivers" v-model="customFieldValues[field.id]" />
                                    </div>
                                </b-col>
                            </b-row>
                            <hr class="m-4" />
                            <b-row class="px-4 mb-7rem">
                                <h3 class="f-18 font-weight-bold col-12 text-left">{{
                                    $t('teamMemberShared.assignedEquipmentHeading') }}</h3>
                                <b-row class="d-flex w-100 px-0 mx-0">
                                    <div
                                        class="d-flex align-items-center gap-3 px-3 w-100 justify-content-between flex-wrap">
                                        <div class="text-left mt-3">
                                            <label class="state">{{ $t('teamMemberShared.vehicleLabel') }}</label>
                                            <v-select class="f-12 min-w-260" :disabled="!allowUpdateDrivers"
                                                :options="vehicleOptions" v-model="defaultVehicle"
                                                :reduce="(option) => option.id" @search="searchVehicle"
                                                @input="getVehicleData">
                                                <!-- Custom dropdown option -->
                                                <template #option="{ label, status }">
                                                    <div class="d-flex align-items-center">
                                                        <span class="equipment-status-indication mr-3"
                                                            :class="status === 'Active' ? 'blue-indication' : 'green-indication'"></span>
                                                        <span>{{ label }}</span>
                                                    </div>
                                                </template>
                                                <template #no-options>
                                                    {{ $t('teamMemberShared.searchUnit') }}
                                                </template>
                                            </v-select>
                                            <a v-if="defaultVehicle" class="text-primary mt-3 f-14 cursor-pointer"
                                                @click="goToVehicleDetail(defaultVehicle, getVehicleLabel())"><u>{{
                                                    $t('editTeamMember.goToVehicle', { label: getVehicleLabel() })
                                                }}</u></a>
                                        </div>
                                        <div class="text-left mt-3 lock-toggle-col">
                                            <div>
                                                <label class="text-left w-fit-content mb-0">{{
                                                    $t('editTeamMember.lockVehicle') }}</label>
                                            </div>
                                            <b-form-checkbox :disabled="!allowUpdateDrivers"
                                                v-model="currentTeamMember.lock_vehicle" name="check-button" switch
                                                size="lg" class="ml-0-6rem"></b-form-checkbox>
                                        </div>
                                    </div>
                                    <b-col sm="12" class="mt-3 text-left" v-if="!this.currentTeamMember.lock_vehicle">
                                        <label class="state">{{ $t('teamMemberShared.vehicleTagLabel') }}</label>
                                        <v-select class="f-12" :options="allTags" multiple :reduce="(option) => option.id"
                                            v-model="vehicleTags" :disabled="!allowUpdateDrivers" />
                                    </b-col>
                                </b-row>
                                <b-row class="d-flex w-100 px-0 mx-0">
                                    <div
                                        class="d-flex align-items-center gap-3 px-3 w-100 justify-content-between flex-wrap">
                                        <div class="text-left mt-3">
                                            <label class="state">{{ $t('teamMemberShared.trailerLabel') }}</label>
                                            <v-select class="f-12 min-w-260" :disabled="!allowUpdateDrivers"
                                                :options="trailerOptions" v-model="defaultTrailer"
                                                :multiple="isMultipleTrailers" :selectable="isTrailerSelectable"
                                                :reduce="(option) => option.id" @search="searchTrailer"
                                                @input="getTrailerData">
                                                <template #option="{ label, status }">
                                                    <div class="d-flex align-items-center">
                                                        <span class="equipment-status-indication mr-3"
                                                            :class="status === 'Active' ? 'blue-indication' : 'green-indication'"></span>
                                                        <span>{{ label }}</span>
                                                    </div>
                                                </template>
                                                <span slot="no-options">
                                                    {{ $t('teamMemberShared.searchUnit') }}
                                                </span>
                                            </v-select>
                                            <div class="d-flex flex-column align-items-start">
                                                <a v-for="trailer in selectedTrailers" :key="trailer.id"
                                                    class="text-primary mt-3 f-14 cursor-pointer"
                                                    @click="goToTrailerDetail(trailer.id, trailer.label)"><u>{{
                                                        $t('editTeamMember.goToTrailer', { label: trailer.label })
                                                    }}</u></a>
                                            </div>
                                        </div>
                                        <div class="text-left mt-3 lock-toggle-col">
                                            <div>
                                                <label class="text-left w-fit-content mb-0">{{
                                                    $t('editTeamMember.lockTrailer') }}</label>
                                            </div>
                                            <b-form-checkbox :disabled="!allowUpdateDrivers"
                                                v-model="currentTeamMember.lock_trailer" name="check-button" switch
                                                size="lg" class="ml-0-6rem"></b-form-checkbox>
                                        </div>
                                    </div>
                                    <b-col sm="12" class="mt-3 text-left" v-if="!this.currentTeamMember.lock_trailer">
                                        <label class="state">{{ $t('teamMemberShared.trailerTagLabel') }}</label>
                                        <v-select class="f-12" :options="allTags" multiple :reduce="(option) => option.id"
                                            v-model="trailerTags" :disabled="!allowUpdateDrivers" />
                                    </b-col>
                                </b-row>
                                <b-col sm="12" class="mt-3"
                                    v-if="currentTeamMember.is_co_driver && currentTeamMember.co_driver">
                                    <b-form-group :label="$t('editTeamMember.leadDriverLabel')" class="text-left mb-0">
                                        <b-form-input v-model="currentTeamMember.co_driver.name" class="bg_white"
                                            disabled />
                                    </b-form-group>
                                </b-col>
                                <b-col sm="12" class="text-left mt-3" v-else>
                                    <label class="state">{{ $t('teamMemberShared.coDriverLabel') }}</label>
                                    <v-select class="f-12" :disabled="!allowUpdateDrivers" :options="coDrivers"
                                        v-model="driver.co_driver" :reduce="(option) => option.id" @input="sameAsDrivername"
                                        @search="searchDriver">
                                        <span slot="no-options">
                                            {{ $t('teamMemberShared.searchName') }}
                                        </span>
                                    </v-select>
                                    <a v-if="driver && driver.co_driver" class="text-primary mt-3 f-14 cursor-pointer"
                                        @click="goToDriverDetail(driver.co_driver, coDrivers.find((item) => item.id === driver.co_driver).label)"><u>{{
                                            $t('editTeamMember.goToCoDriver', {
                                                label: coDrivers.find((item) => item.id ===
                                                    driver.co_driver).label
                                            }) }}</u></a>
                                </b-col>
                            </b-row>
                        </div>
                    </v-tab-item>
                    <v-tab-item key='documents' v-if="allowViewDocDrivers">
                        <div class="d-block body mb-7rem">
                            <div class="mb-3 d-flex align-items-center justify-content-between px-4 mt-4rem">
                                <h3 class="f-18 font-weight-bold text-left px-0 mb-0">{{ $t('editTeamMember.documentsTab')
                                }}</h3>
                                <div class="d-flex align-items-center justify-content-end cursor-pointer"
                                    v-if="allowCreateDocDrivers" @click="addDocument">
                                    <svg width="13" height="13" viewBox="0 0 13 13" fill="none"
                                        xmlns="http://www.w3.org/2000/svg">
                                        <path d="M6.5 12V6.5V12ZM6.5 6.5V1V6.5ZM6.5 6.5H12H6.5ZM6.5 6.5H1H6.5Z"
                                            fill="#367BF6" />
                                        <path d="M6.5 12V6.5M6.5 6.5V1M6.5 6.5H12M6.5 6.5H1" stroke="#367BF6"
                                            stroke-width="1.5" stroke-linecap="round" />
                                    </svg>
                                    <p class="text_primary ml-2 mb-0 fw-600">{{ $t('editTeamMember.addDocument') }}</p>
                                </div>
                            </div>
                            <div class="px-4">
                                <div v-if="items.length === 0"
                                    class="text-center text-muted py-4 bg-white rounded document-card-empty">
                                    {{ $t('editTeamMember.noDocuments') }}
                                </div>
                                <div v-for="section in docSections" :key="section.key" class="doc-section">
                                    <template v-if="section.title">
                                        <hr class="my-4" />
                                        <h3 class="f-18 font-weight-bold text-left mb-3">{{ section.title }}</h3>
                                    </template>
                                    <div class="document-cards-list">
                                        <div v-for="item in section.docs" :key="item.pk" class="document-card">
                                            <div class="document-card-top">
                                                <span class="document-card-title">
                                                    {{ item.Description && item.Description !== 'null' ? item.Description :
                                                        '-' }}
                                                </span>
                                                <span class="document-card-date" v-html="item.expiry_date">

                                                </span>
                                            </div>
                                            <div class="document-card-divider"></div>
                                            <div class="document-card-bottom">
                                                <div class="document-card-switches ml-2">
                                                    <b-form-checkbox :disabled="!allowUpdateDocDrivers" v-model="item.Driver"
                                                        name="check-button" switch size="lg"
                                                        @change="updateDocumentOnToggle(item.id, 'driver', item.Driver)">
                                                        <span class="document-card-label">{{ $t('editTeamMember.driverDocLabel')
                                                        }}</span>
                                                    </b-form-checkbox>
                                                    <!-- <b-form-checkbox :disabled="!allowUpdateDocDrivers"
                                                        v-model="item.dot_mode" name="check-button" switch size="lg"
                                                        @change="updateDocumentOnToggle(item.id, 'dot_mode', item.dot_mode)">
                                                        <span class="document-card-label">DOT Mode</span>
                                                    </b-form-checkbox> -->
                                                </div>
                                                <div class="document-card-actions">
                                                    <svg @click="editDocument(item.id, item.pk)" class="cursor-pointer"
                                                        width="20" height="15" viewBox="0 0 20 15" fill="none"
                                                        xmlns="http://www.w3.org/2000/svg">
                                                        <path
                                                            d="M18.6426 6.19707C18.8726 6.48384 19 6.85642 19 7.24273C19 7.62904 18.8726 8.00161 18.6426 8.28838C17.186 10.052 13.8704 13.4854 10 13.4854C6.12957 13.4854 2.81403 10.052 1.35741 8.28838C1.12735 8.00161 1 7.62904 1 7.24273C1 6.85642 1.12735 6.48384 1.35741 6.19707C2.81403 4.4335 6.12957 1 10 1C13.8704 1 17.186 4.4335 18.6426 6.19707Z"
                                                            stroke="#2D69F6" stroke-width="1.5" stroke-linecap="round"
                                                            stroke-linejoin="round" />
                                                        <path
                                                            d="M10.0007 10.0154C11.533 10.0154 12.7752 8.77323 12.7752 7.24091C12.7752 5.70859 11.533 4.4664 10.0007 4.4664C8.46839 4.4664 7.2262 5.70859 7.2262 7.24091C7.2262 8.77323 8.46839 10.0154 10.0007 10.0154Z"
                                                            stroke="#2D69F6" stroke-width="1.5" stroke-linecap="round"
                                                            stroke-linejoin="round" />
                                                    </svg>
                                                    <svg @click="downloadDoc(item.pk, item.name)" class="cursor-pointer"
                                                        width="20" height="20" viewBox="0 0 20 20" fill="none"
                                                        xmlns="http://www.w3.org/2000/svg">
                                                        <path d="M6.53943 11.3822L10.001 14.8437L13.4625 11.3822"
                                                            stroke="#FFC800" stroke-width="1.5" stroke-linecap="round"
                                                            stroke-linejoin="round" />
                                                        <path d="M10.0001 14.8497V5.15741" stroke="#FFC800" stroke-width="1.5"
                                                            stroke-linecap="round" stroke-linejoin="round" />
                                                        <path
                                                            d="M10 19C14.9706 19 19 14.9706 19 10C19 5.02944 14.9706 1 10 1C5.02944 1 1 5.02944 1 10C1 14.9706 5.02944 19 10 19Z"
                                                            stroke="#FFC800" stroke-width="1.5" stroke-linecap="round"
                                                            stroke-linejoin="round" />
                                                    </svg>
                                                    <svg v-if="allowDeleteDocDrivers"
                                                        @click="showArchivePopup(item.pk, item.is_archived)"
                                                        class="cursor-pointer" width="20" height="17" viewBox="0 0 20 17"
                                                        fill="none" xmlns="http://www.w3.org/2000/svg">
                                                        <path
                                                            d="M17.6154 4.40909L17.0385 14.0745C17.0074 14.5955 16.7753 15.0851 16.3897 15.443C16.0041 15.8009 15.4942 16.0002 14.9643 16H5.03569C4.50581 16.0002 3.99589 15.8009 3.6103 15.443C3.22471 15.0851 2.99262 14.5955 2.96154 14.0745L2.38462 4.40909M8.15385 7.81818H11.8462M2.03846 4.40909H17.9615C18.5348 4.40909 19 3.95091 19 3.38636V2.02273C19 1.45818 18.5348 1 17.9615 1H2.03846C1.46523 1 1 1.45818 1 2.02273V3.38636C1 3.95091 1.46523 4.40909 2.03846 4.40909Z"
                                                            stroke="#FF7900" stroke-width="1.5" stroke-linecap="round"
                                                            stroke-linejoin="round" />
                                                    </svg>
                                                    <svg @click="showPopup(item.pk)" class="cursor-pointer"
                                                        v-if="allowDeleteDocDrivers" width="19" height="20" viewBox="0 0 19 20"
                                                        fill="none" xmlns="http://www.w3.org/2000/svg">
                                                        <path d="M1 5.15704H17.6139" stroke="#FF0000" stroke-width="1.5"
                                                            stroke-linecap="round" stroke-linejoin="round" />
                                                        <path
                                                            d="M3.0766 5.15704H15.537V17.6175C15.537 17.9846 15.3911 18.3368 15.1315 18.5964C14.8719 18.856 14.5197 19.0019 14.1525 19.0019H4.46109C4.0939 19.0019 3.74175 18.856 3.4821 18.5964C3.22247 18.3368 3.0766 17.9846 3.0766 17.6175V5.15704Z"
                                                            stroke="#FF0000" stroke-width="1.5" stroke-linecap="round"
                                                            stroke-linejoin="round" />
                                                        <path
                                                            d="M5.84607 5.15347V4.46123C5.84607 3.54325 6.21073 2.66287 6.85984 2.01377C7.50894 1.36466 8.38932 1 9.3073 1C10.2253 1 11.1057 1.36466 11.7548 2.01377C12.4039 2.66287 12.7685 3.54325 12.7685 4.46123V5.15347"
                                                            stroke="#FF0000" stroke-width="1.5" stroke-linecap="round"
                                                            stroke-linejoin="round" />
                                                        <path d="M7.23175 9.3065V14.8466" stroke="#FF0000" stroke-width="1.5"
                                                            stroke-linecap="round" stroke-linejoin="round" />
                                                        <path d="M11.385 9.3065V14.8466" stroke="#FF0000" stroke-width="1.5"
                                                            stroke-linecap="round" stroke-linejoin="round" />
                                                    </svg>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </v-tab-item>
                    <v-tab-item key="notes">
                        <div class="mt-4rem">
                            <Notes :key="currentTeamMember.id" :noteURL="'app/driver/' + currentTeamMember.id + '/note'"
                                :allowUpdate="allowUpdateDrivers" @updateNotes="$emit('updateData', true)" />
                        </div>
                    </v-tab-item>
                    <v-tab-item key="activity" v-if="showActivitySection">
                        <div class="mt-4rem mb-6rem">
                            <ActivityLogs :key="currentTeamMember.id" :record="currentTeamMember.name"
                                :object_id="currentTeamMember.id" />
                        </div>
                    </v-tab-item>
                </v-tabs-items>
                <div class="sidebar-footer position-fixed">
                    <div class="d-flex align-items-center justify-content-end" v-if="allowUpdateDrivers">
                        <div class="text-right modal-footer border-0 p-0">
                            <b-button class="mx-0 h-40px w-100px m-0" @click="closePopup" variant="secondary"
                                :class="hasChanged && allowUpdateDrivers && activeTab === 0 ? 'mr-3' : ''">{{ $t('teamMemberShared.close')
                                }}</b-button>
                            <b-button class="mx-0 mb-0 h-40px w-100px m-0" v-if="hasChanged && allowUpdateDrivers && activeTab === 0"
                                variant="primary" @click="updateTeamMemberData">{{ $t('teamMemberShared.save') }}</b-button>
                        </div>
                    </div>
                    <div v-else class="text-right">
                        <b-button class="mx-0 h-40px w-100px m-0" @click="closePopup" variant="secondary">{{
                            $t('teamMemberShared.close') }}</b-button>
                    </div>
                </div>
            </div>
        </b-sidebar>
        <b-modal id="modal-password" centered no-close-on-esc no-close-on-backdrop :footer-class="'d-block p-3 m-0'">
            <template #modal-header="{ close }">
                <h5 class="modal-title">
                    {{ $t('editTeamMember.setPasswordModalTitle') }}
                </h5>
                <b-button size="sm" class="d-none" variant="outline-danger" @click="close()">
                    Close Modal
                </b-button>
            </template>
            <div class="d-block text-center">
                <b-row align-v="center">
                    <b-col md="12">
                        <b-form-group :label="$t('editTeamMember.passwordLabel')"
                            class="text-left label font-weight-normal password show-password-section">
                            <b-form-input id="pass-field" v-model="password" :type="showPassword ? 'text' : 'password'"
                                class="mb-2" :placeholder="$t('teamMemberShared.passwordPlaceholder')" />
                            <b-icon :icon="showPassword ? 'eye-fill' : 'eye-slash-fill'"
                                @click="showPassword = !showPassword"></b-icon>
                            <p v-if="errors && errors.password" class="field-error float-start">
                                {{ errors.password[0] }}
                            </p>
                        </b-form-group>
                    </b-col>
                </b-row>
            </div>
            <template #modal-footer>
                <div class="text-right modal-footer border-0 p-0 mb-0 mt-0">
                    <b-button class="mx-0 mr-3 h-40px w-100px m-0" @click="$bvModal.hide('modal-password')"
                        variant="secondary">{{ $t('teamMemberShared.cancel') }}</b-button>
                    <div class="d-flex align-items m-0">
                        <b-button class="mx-0 mb-0 h-40px w-100px m-0" variant="primary" @click="setPass">{{
                            $t('teamMemberShared.save') }}</b-button>
                    </div>
                </div>
            </template>
        </b-modal>
        <DeleteModal :message="$t('editTeamMember.deleteDocConfirm')" v-if="showDocumentModal"
            @confirm="deleteDocumentItem($event)" />
        <DeleteModal :message="$t('editTeamMember.deleteDriverConfirm')" v-if="showDeleteDriverModal"
            @confirm="deleteDriverItem($event)" />
        <DeleteModal
            :message="unarchiveDocument ? $t('editTeamMember.unarchiveDocConfirm') : $t('editTeamMember.archiveDocConfirm')"
            :updateMessage="true" :removeMessage="''" v-if="showArchiveDocumentModal"
            @confirm="archiveDocumentItem($event)" />
        <DeleteModal v-if="showMemberModal" @confirm="changeDriverStatusItem($event)"
            :message="currentTeamMember.status ? $t('editTeamMember.deactivateConfirm') : $t('editTeamMember.activateConfirm')"
            :removeMessage="currentTeamMember.status ? 'Deactivate' : ''"
            :successMessage="!currentTeamMember.status ? 'Activate' : ''" />
        <DeleteModal :message="assignedEquipmentMessage" :updateMessage="true" :removeMessage="''"
            v-if="assignedEquipmentMessage" @confirm="verifyEquipmentStatus" />
        <AddTags v-if="showTagsModal" @confirmTags="addTag($event)" :existingTags="currentTeamMember.tags" :type="'Driver'"
            :driverID="driverID" :co_driver="driver.co_driver" />
        <b-modal id="modal-document" centered @shown="resetField" no-close-on-backdrop size="lg"
            :body-class="'px-3 pt-2 overflow-preview-auto'" no-close-on-esc :footer-class="'d-block border-0 pt-0 pb-3 m-0'"
            :header-class="'align-items-center'" scrollable>
            <template #modal-header="{ close }">
                <h5 class="modal-title">
                    {{ $t('editTeamMember.documentTitle') }}
                </h5>
                <b-button size="sm" class="d-none" variant="outline-danger" @click="close()">
                    Close Modal
                </b-button>
                <b-dropdown id="dropdown-preview" class="load-dropdown mt-0" v-if="editDocumentFlag">
                    <template slot="button-content">
                        <b-icon class="dots" icon="three-dots"></b-icon>
                    </template>
                    <b-dropdown-item-button
                        :class="(fileName && allowUpdateDocDrivers && editDocumentFlag) || allowDeleteDocDrivers ? 'mb-2' : ''"
                        @click="downloadDoc(documentData.id, `${currentTeamMember.user.first_name} ${currentTeamMember.user.last_name}-${documentData.description ? documentData.description : ''}`)">
                        <p class="text_secondary cursor-pointer mb-0 f-14">{{ $t('editTeamMember.download') }}</p>
                    </b-dropdown-item-button>
                    <b-dropdown-item-button class='mb-2' v-if="(fileName && allowUpdateDocDrivers && editDocumentFlag)"
                        :class="allowDeleteDocDrivers ? 'mb-2' : ''" @click="removeFile()">
                        <p class="text_secondary cursor-pointer mb-0 f-14">{{ $t('editTeamMember.replaceDoc') }}</p>
                    </b-dropdown-item-button>
                    <b-dropdown-item-button @click="showArchivePopup(documentData.id, documentData.is_archived)"
                        class="mb-2" v-if="allowDeleteDocDrivers">
                        <p class="text_secondary cursor-pointer mb-0 f-14">{{ documentData.is_archived ?
                            $t('editTeamMember.unarchive') : $t('editTeamMember.archive') }}</p>
                    </b-dropdown-item-button>
                    <b-dropdown-item-button @click="showPopup(documentData.id)" v-if="allowDeleteDocDrivers">
                        <p class="text_secondary cursor-pointer mb-0 f-14">{{ $t('editTeamMember.delete') }}</p>
                    </b-dropdown-item-button>
                </b-dropdown>
                <b-dropdown id="dropdown-preview" text="text" class="load-dropdown mt-0"
                    v-if="!editDocumentFlag && fileName">
                    <template slot="button-content">
                        <b-icon class="dots" icon="three-dots"></b-icon>
                    </template>
                    <b-dropdown-item-button @click="removeFile()">
                        <p class="text_secondary cursor-pointer mb-0 f-14">{{ $t('editTeamMember.replaceDoc') }}</p>
                    </b-dropdown-item-button>
                </b-dropdown>
            </template>
            <div class="d-block text-center">
                <b-row>
                    <b-col lg="4" md="8" sm="12">
                        <div class="text-left mb-3">
                            <label for="modal-datepicker" class="state">{{ $t('editTeamMember.dateLabel') }}</label>
                            <date-picker v-model="documentData.date" :formatter="momentFormat" :range-separator="' - '"
                                @clear="documentData.date = ''" :placeholder="$t('teamMemberShared.selectDate')"
                                class="date-picker-custom" :teleport="'body'"
                                :disabled="!allowUpdateDocDrivers"></date-picker>
                            <p v-if="errors && errors.date" class="field-error">
                                {{ errors.date[0] }}
                            </p>
                        </div>
                        <div class="text-left mb-3">
                            <label for="modal-expiry-date" class="state">{{ $t('editTeamMember.expiryDateLabel') }}</label>
                            <date-picker v-model="documentData.expiry_date" :formatter="momentFormat"
                                :range-separator="' - '" @clear="documentData.expiry_date = ''"
                                :placeholder="$t('teamMemberShared.selectDate')" class="date-picker-custom"
                                :teleport="'body'" :disabled="!allowUpdateDocDrivers"></date-picker>
                            <p v-if="errors && errors.expiry_date" class="field-error">
                                {{ errors.expiry_date[0] }}
                            </p>
                        </div>
                        <div class="text-left mb-3">
                            <label class="state">{{ $t('editTeamMember.typeLabel') }}</label>
                            <b-form-select class="f-12" :options="getDotOptions" v-model="documentData.doc_type"
                                @change="setDocDescription($event)" :disabled="!allowUpdateDocDrivers">
                            </b-form-select>
                            <p v-if="errors && errors.doc_type" class="field-error">
                                {{ errors.doc_type[0] }}
                            </p>
                        </div>
                        <div class="text-left mb-3">
                            <label class="state">{{ $t('editTeamMember.descriptionLabel') }}</label>
                            <b-form-textarea id="textarea" :placeholder="$t('editTeamMember.descriptionPlaceholder')"
                                rows="3" v-model="documentData.description"
                                :disabled="!allowUpdateDocDrivers"></b-form-textarea>
                            <p v-if="errors && errors.description" class="field-error pb-4">
                                {{ errors.description[0] }}
                            </p>
                        </div>
                        <div class="text-left mb-3">
                            <label class="state">{{ $t('editTeamMember.driverToggleLabel') }}</label>
                            <b-form-checkbox v-model="documentData.driver" :disabled="!allowUpdateDocDrivers"
                                name="check-button" switch size="lg" class="ml-0-6rem" />
                        </div>
                        <div class="text-left">
                            <label class="state">{{ $t('editTeamMember.dotModeLabel') }}</label>
                            <b-form-checkbox :disabled="!allowUpdateDocDrivers" v-model="documentData.dot_mode"
                                name="check-button" switch size="lg" class="ml-0-6rem" />
                        </div>
                    </b-col>
                    <b-col lg="8" sm="12">
                        <div class="upload-btn-wrapper" v-if="!fileName">
                            <b-img :src="require('@/assets/drop.svg')"></b-img>
                            <button v-if="!fileName" class="foo">
                                {{ $t('editTeamMember.dropDocument') }}
                            </button>
                            <button v-else class="foo">{{ fileName }}</button>

                            <input ref="docFile" type="file" name="docFile" v-on:change="handleFileUpload"
                                accept=".pdf, .png, .jpg, .jpeg" />
                            <p v-if="errors && errors.document" class="field-error">
                                {{ errors.document[0] }}
                            </p>
                        </div>
                        <div v-else>
                            <div class="review-media-section" :class="mediaType === 'pdf' ? 'overflow-hidden' : ''">
                                <iframe class="w-100 h-100 border-0" v-if="mediaType === 'pdf'" :src="media"></iframe>
                                <div v-else>
                                    <div id="panzoom-element" ref="panzoomElement">
                                        <img :src="media" class="w-100 h-100 img-section" />
                                    </div>
                                    <div class="d-flex align-items-center justify-content-center zoom-section">
                                        <b-icon @click="zoom(1)" icon="zoom-in"
                                            style="fill:white; cursor: pointer;"></b-icon>
                                        <b-icon @click="zoom(-1)" class="ml-3" icon="zoom-out"
                                            style="fill:white;cursor: pointer;"></b-icon>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </b-col>
                </b-row>
            </div>
            <template #modal-footer>
                <div class="text-right modal-footer border-0 p-0 mt-4">
                    <b-button class="mx-0 h-40px w-100px m-0" @click="$bvModal.hide('modal-document'); panzoom = null"
                        variant="secondary" :class="hasDocChanged && hasDocChanged ? 'mr-3' : ''">{{ editDocumentFlag ?
                            $t('teamMemberShared.close') : $t('teamMemberShared.cancel') }}</b-button>
                    <b-button class="mx-0 mb-0 h-40px w-100px m-0" variant="primary" @click="sendDocumentData"
                        v-if="hasDocChanged && allowUpdateDocDrivers">{{ $t('teamMemberShared.save') }}</b-button>
                </div>
            </template>
        </b-modal>
        <SendInvite v-if="driverID" @sendInvite="sentInvitetoDriver($event)" />
        <DriverQRPassword v-if="driverID" @generateQRCode="generateDriverQRCode($event)" />
        <qriously v-if="currentTeamMember" class="d-none" :value="qrCodeValue" :size="200" ref="qrcode" />
    </div>
</template>
<script>
import { mapActions, mapGetters } from "vuex";
import "vue-select/dist/vue-select.css";
import { areAllDigitsSame } from '../../services/helper';
import AddTags from "@/components/Equipment/AddTags.vue";
import vSelect from "vue-select";
import DeleteModal from "@/components/DeleteModal.vue";
import * as moment from "moment-timezone";
import generateQRCode from '../../services/generateDriverQRCode';
import { checkEmail, checkValueExists, checkPhoneFormat, checkDescriptionLength } from "../../services/helper";
import SendInvite from "./SendInvite.vue";
import DriverQRPassword from "./DriverQRPassword.vue";
import ActivityLogs from "@/components/Shared/ActivityLogs.vue"
import Panzoom from '@panzoom/panzoom'
import Notes from "../Shared/Notes";
import DatePicker from 'vue2-datepicker';
import 'vue2-datepicker/index.css';

export default {
    props: ["driverID", "states", "options", "setNotesSection"],
    components: { DeleteModal, AddTags, SendInvite, DriverQRPassword, vSelect, ActivityLogs, Notes, DatePicker },
    name: "Edit-Teammember",
    data() {
        return {
            checkEmail,
            checkValueExists,
            checkPhoneFormat,
            checkDescriptionLength,
            qrCodeValue: "",
            showDeleteDriverModal: false,
            panzoom: null,
            requiredDocsRecords: [],
            userTimeZone: Intl.DateTimeFormat().resolvedOptions().timeZone,
            userActiveStatus: false,
            qrCodeUrl: null,
            existingTags: [],
            vehicleTags: [],
            trailerTags: [],
            driverCustomFields: [],
            customFieldValues: {},
            defaultCustomFieldValues: {},
            media: null,
            mediaType: null,
            docName: null,
            mediaID: null,
            activeTab: "info",
            fileName: "",
            coDrivers: [],
            password: "",
            showPassword: false,
            vehicleOptions: [],
            trailerOptions: [],
            showTagsModal: false,
            showDocumentModal: false,
            showMemberModal: false,
            memberPinCode: null,
            memberUsername: "",
            emptyTable: false,
            errors: {},
            itemId: null,
            showArchiveDocumentModal: false,
            unarchiveDocument: false,
            num_docs: 0,
            currentPage: 1,
            defaultVehicle: null,
            defaultTrailer: null,
            pendingTrailerId: null,
            items: [],
            driver: {
                sameAsDriver: false,
                co_driver: null,
            },
            fields: [
                {
                    key: "Description",
                    sortable: true,
                    thClass: 'font-table-weight-bold'
                },
                {
                    key: "expiry_date",
                    label: "Expiry Date",
                    sortable: true,
                    thClass: 'font-table-weight-bold'
                },
                {
                    key: "Driver",
                    sortable: true,
                    thClass: 'font-table-weight-bold'
                },
                {
                    key: "Action",
                    sortable: true,
                    thClass: 'font-table-weight-bold'
                },
            ],
            editDocumentFlag: false,
            documentIndex: null,
            assignedEquipmentMessage: "",
            assignedExistingTrailer: false,
            assignedExistingVehicle: false,
            documentData: {
                object_id: null,
                date: null,
                type: null,
                expiry_date: "",
                document: null,
                description: "",
                driver: true,
                dot_mode: true,
                doc_type: ""
            },
            defaultData: {},
            momentFormat: {
                stringify: (date) => {
                    return date ? moment(date).format('ll') : ''
                },
                parse: (value) => {
                    if (!value) return null
                    const formats = [
                        'll', 'LL',
                        'MMM D, YYYY', 'MMMM D, YYYY',
                        'M/D/YYYY', 'MM/DD/YYYY',
                        'M-D-YYYY', 'MM-DD-YYYY',
                        'YYYY-MM-DD', 'YYYY/MM/DD',
                        'D MMM YYYY', 'D MMMM YYYY',
                        'D/M/YYYY', 'DD/MM/YYYY',
                    ]
                    const m = moment(value, formats, true)
                    if (m.isValid()) return m.toDate()
                    const lenient = moment(value)
                    return lenient.isValid() ? lenient.toDate() : null
                }
            },
            defaultDocsData: {},
            documentOptions: [
                {
                    value: null,
                    text: "",
                },
                {
                    value: "License",
                    text: "License",
                },
                {
                    value: "MVR",
                    text: "MVR",
                },
                {
                    value: "Medical Card",
                    text: "Medical Card",
                },
                {
                    value: "Insurance",
                    text: "Insurance",
                },
                {
                    value: "Drug Test",
                    text: "Drug Test",
                },
                {
                    value: "Other",
                    text: "Other",
                },
            ],
        }
    },
    computed: {
        ...mapGetters([
            "currentTeamMember",
            "company",
            "allDrivers",
            "allEquipments",
            "userCompany",
            "tags",
            "docTypeItems",
            "defaultDocType",
            "divisions",
            'rolePermissions'
        ]),
        requiredDocsMessage() {
            const docTypes = this.getMissingDocTypes(this.requiredDocsRecords);
            return docTypes.length
                ? this.$t('editTeamMember.requiredDocsMissing', { docs: docTypes.join(', ') })
                : this.$t('editTeamMember.requiredDocsMissingCount', { count: this.requiredDocsRecords.length });
        },
        getAllowedTrailers(){
            return this.company[0]?.number_of_allowed_trailers
        },
        isMultipleTrailers() {
            return this.getAllowedTrailers > 1
        },
        docSections() {
            if (!this.items.length) return []
            return [
                { key: 'all', title: '', docs: this.items.filter((item) => !item.is_archived) },
                {
                    key: 'archived',
                    title: this.$t('editTeamMember.archivedDocsHeading'),
                    docs: this.items.filter((item) => item.is_archived)
                }
            ].filter((section) => section.docs.length)
        },
        selectedTrailerIds() {
            if (!this.defaultTrailer) return []
            return Array.isArray(this.defaultTrailer) ? this.defaultTrailer : [this.defaultTrailer]
        },
        selectedTrailers() {
            return this.selectedTrailerIds
                .map((id) => this.trailerOptions.find((option) => option.id === id))
                .filter(Boolean)
        },
        hasTrailerChanged() {
            const assignedIds = (this.defaultData?.assigned_trailers || []).map((trailer) => trailer?.id ?? trailer)
            return this.selectedTrailerIds.toString() !== assignedIds.toString()
        },
        getEnterpriseStatus() {
            return (this.company[0]?.subscription?.type === 'Enterprise' && this.company[0]?.subscription?.status === 'active')
        },
        showActivitySection() {
            return this.rolePermissions && this.rolePermissions['Activity Log'] && this.rolePermissions['Activity Log'][0].allow
        },
        allowUpdateDrivers() {
            return this.rolePermissions && this.rolePermissions['Drivers'] && this.rolePermissions['Drivers'][2].allow
        },
        allowDeleteDriver() {
            return this.rolePermissions && this.rolePermissions['Drivers'] && this.rolePermissions['Drivers'][5].allow
        },
        allowViewDocDrivers() {
            return this.rolePermissions && this.rolePermissions['Drivers'] && this.rolePermissions['Drivers'][7].allow
        },
        allowCreateDocDrivers() {
            return this.rolePermissions && this.rolePermissions['Drivers'] && this.rolePermissions['Drivers'][9].allow
        },
        allowUpdateDocDrivers() {
            return this.rolePermissions && this.rolePermissions['Drivers'] && this.rolePermissions['Drivers'][8].allow
        },
        allowDeleteDocDrivers() {
            return this.rolePermissions && this.rolePermissions['Drivers'] && this.rolePermissions['Drivers'][10].allow
        },
        allDivisions() {
            return this.divisions.map((item) => {
                return {
                    id: item.id,
                    label: item.division,
                }
            })
        },
        hasChanged() {
            return JSON.stringify(this.customFieldValues) !== JSON.stringify(this.defaultCustomFieldValues) || this.defaultData.user?.username?.split(
                `.${this.company[0]?.company_ID}`
            )[0] != this.memberUsername || this.defaultData.driverPhoneNumber !== this.driverPhoneNumber || this.checkValueExists(this.defaultData['default_vehicle']?.id) != this.defaultVehicle || this.hasTrailerChanged || this.checkValueExists(this.defaultData['co_driver']?.id) != this.driver.co_driver || this.existingTags.toString() !== this.currentTeamMember?.tags?.map((tag) => tag.id).toString() || this.vehicleTags.toString() !== this.currentTeamMember?.vehicle_assignment_tags?.map((tag) => tag.id).toString() || this.trailerTags.toString() !== this.currentTeamMember?.trailer_assignment_tags?.map((tag) => tag.id).toString() || Object.keys(this.currentTeamMember).filter(field => {
                if (field !== 'docs' && field !== 'phone' && field !== 'updated_at' && field !== 'company' && field !== 'co_driver' && field !== 'default_vehicle' && field !== 'default_trailer' && field !== 'dispatch_name') {
                    if (typeof this.currentTeamMember[field] === 'object') return JSON.stringify(this.currentTeamMember[field]) !== JSON.stringify(this.defaultData[field])
                    else if (!this.currentTeamMember[field] && !this.defaultData[field]) return false
                    else return this.checkValueExists(this.currentTeamMember[field]) != this.checkValueExists(this.defaultData[field])
                } return false
            }).length > 0
        },
        hasDocChanged() {
            return Object.keys(this.documentData).filter(field => {
                if (field !== 'updated_at') {
                    if (typeof this.documentData[field] === 'object') return JSON.stringify(this.documentData[field]) !== JSON.stringify(this.defaultDocsData[field])
                    if (field === 'description') {
                        return this.checkValueExists(this.documentData[field]?.trim()?.replace(/\r\n|\r|\n/g, '\n')) != this.checkValueExists(this.defaultDocsData[field]?.trim()?.replace(/\r\n|\r|\n/g, '\n'));
                    }
                    else if (!this.documentData[field] && !this.defaultDocsData[field]) return false
                    else return this.checkValueExists(this.documentData[field]) != this.checkValueExists(this.defaultDocsData[field])
                } return false
            }).length > 0
        },
        driverPhoneNumber: {
            get: function () {
                return this.currentTeamMember.phone ? this.currentTeamMember.phone.startsWith("+1") ? this.currentTeamMember.phone.slice(2).trim() : this.currentTeamMember.phone : ''
            },
            set: function (newValue) {
                this.currentTeamMember.phone = newValue
            }
        },
        phoneMask() {
            return this.driverPhoneNumber?.length > 0
                ? [
                    /\d/, /\d/, /\d/, " ",
                    /\d/, /\d/, /\d/, " ",
                    /\d/, /\d/, /\d/, /\d/
                ]
                : false; // Allows empty input
        },
        divisionId: {
            get() {
                return this.currentTeamMember?.division?.id || null;
            },
            set(value) {
                if (!this.currentTeamMember.division) {
                    this.currentTeamMember.division = {};
                }
                this.currentTeamMember.division.id = value;
            }
        },
        getDotOptions() {
            return [...[{
                value: "",
                text: "",
            }], ...this.docTypeItems?.filter((item) => item.model === 'Driver' || item.model === 'All').map((item) => {
                return {
                    value: item.id,
                    text: item.type,
                }
            })]
        },
        allTags() {
            return this.tags.map((item) => {
                return {
                    id: item.id,
                    label: item.add_tag,
                }
            })
        }
    },
    watch: {
        currentTeamMember() {
            if (this.currentTeamMember) {
                this.existingTags = this.currentTeamMember?.tags.map((item) => item.id);
                this.vehicleTags = this.currentTeamMember?.vehicle_assignment_tags.map((item) => item.id);
                this.trailerTags = this.currentTeamMember?.trailer_assignment_tags.map((item) => item.id);
                this.applyCustomFieldValues();
            }
        },
        driverID: {
            async handler() {
                if (this.driverID) {
                    this.activeTab = 'info'
                    try {
                        this.setLoader(true)
                        this.requiredDocsRecords = []
                        await this.loadDriverCustomFields();
                        await this.getTeamMember({ id: this.driverID, fetch_user: false });
                        await this.getAllTags(this.userCompany);
                        await this.loadRequiredDocs();
                        this.userActiveStatus = this.currentTeamMember.status
                        this.memberUsername = this.currentTeamMember.user.username.split(
                            `.${this.company[0].company_ID}`
                        )[0];
                        if (this.currentTeamMember.dob) {
                            this.currentTeamMember.dob = moment.tz(this.currentTeamMember.dob, this.userTimeZone).toDate();
                        }
                        if (this.currentTeamMember.activate_date) {
                            this.currentTeamMember.activate_date = moment.tz(this.currentTeamMember.activate_date, this.userTimeZone).toDate();
                        }
                        if (this.currentTeamMember.inactive_date) {
                            this.currentTeamMember.inactive_date = moment.tz(this.currentTeamMember.inactive_date, this.userTimeZone).toDate();
                        }
                        this.defaultData = JSON.parse(JSON.stringify({ ...this.currentTeamMember, driverPhoneNumber: this.currentTeamMember.phone ? this.currentTeamMember.phone.startsWith("+1") ? this.currentTeamMember.phone.slice(2).trim() : this.currentTeamMember.phone : '' }))
                        if (this.setNotesSection) {
                            if (this.allowViewDocDrivers) {
                                this.activeTab = 2
                            }
                            else this.activeTab = 1
                        }
                        if (this.currentTeamMember.default_vehicle) {
                            this.defaultVehicle = this.currentTeamMember.default_vehicle.id;
                            if (this.currentTeamMember.default_vehicle) {
                                this.vehicleOptions.push({
                                    id: this.currentTeamMember.default_vehicle.id,
                                    label: `${this.currentTeamMember.default_vehicle.unit_no} | ${this.currentTeamMember.default_vehicle.division_name}`,
                                    division_name: this.currentTeamMember.default_vehicle.division_name
                                });
                            }
                        }
                        else {
                            this.defaultVehicle = null
                            this.vehicleOptions = []
                        }
                        if (this.currentTeamMember.assigned_trailers.length > 0) {
                            const assignedTrailers = this.isMultipleTrailers
                                ? this.currentTeamMember.assigned_trailers.slice(0, this.getAllowedTrailers)
                                : [this.currentTeamMember.assigned_trailers[0]];
                            this.defaultTrailer = this.isMultipleTrailers
                                ? assignedTrailers.map((trailer) => trailer.id)
                                : assignedTrailers[0].id;
                            assignedTrailers.forEach((trailer) => {
                                this.trailerOptions.push({
                                    id: trailer.id,
                                    label: `${trailer.unit_no} | ${trailer.division_name}`,
                                    division_name: trailer.division_name
                                });
                            });
                        } else {
                            this.defaultTrailer = this.isMultipleTrailers ? [] : null
                            this.trailerOptions = []
                        }
                        await this.$nextTick();
                        if (this.currentTeamMember.co_driver) {
                            this.coDrivers.push({
                                id: this.currentTeamMember.co_driver.id,
                                label: this.currentTeamMember.co_driver.name,
                            });
                            this.coDrivers = this.coDrivers.sort((a, b) =>
                                a.label.localeCompare(b.label)
                            );
                        } else this.coDrivers = []
                        if (this.currentTeamMember.role === "Driver" && this.currentTeamMember.pin_code) {
                            this.memberPinCode = this.currentTeamMember.pin_code;
                        }
                        this.driver.co_driver = this.currentTeamMember.co_driver
                            ? this.currentTeamMember.co_driver.id
                            : null;
                        this.updateDocs();
                        await this.$nextTick();
                        this.setLoader(false)
                    }
                    catch (e) {
                        console.log(e)
                    }
                }
            },
            immediate: true
        }
    },
    methods: {
        ...mapActions([
            "getTeamMember",
            "getAllTags",
            "setPasswordforAllDrivers",
            "setNotification",
            "getFilteredDrivers",
            "updateTeamMember",
            "deleteTeamMember",
            "setLoader",
            "sendInvite",
            "sendTeamMemberDocument",
            "updateTeamMemberDocument",
            "deleteCompanyDocument",
            "getFilteredEquipments",
            "retrieveDocument",
            "changeDriverStatus",
            "sendBulkInvite",
            "getCustomFields",
            "getAllRequiredDocs"
        ]),
        getMissingDocTypes(records) {
            return [...new Set(
                (records || [])
                    .flatMap((record) => record.missing_doc_type_ids || [])
                    .map((id) => this.docTypeItems.find((item) => item.id === id)?.type)
                    .filter(Boolean)
            )];
        },
        // Options are labelled "<unit no> | <division>", which is what the report searches on.
        getUnitNo(label) {
            return String(label || '').split(' | ')[0].trim();
        },
        async getEquipmentMissingDocs(unitNo, type) {
            try {
                if (!unitNo) return [];
                this.setLoader(true);
                const url = `page=1&page_size=25&search=${encodeURIComponent(unitNo)}&type=${type}&required=True`;
                const requiredDocs = await this.getAllRequiredDocs(url);
                return requiredDocs?.records || [];
            } catch (e) {
                console.log(e);
                return [];
            } finally {
                this.setLoader(false);
            }
        },
        // When the equipment is already taken by another driver that message is shown first, so
        // the missing-docs warning is folded into it rather than opening a second popup.
        buildMissingDocsMessage(unitNo, records, appendToExisting = false) {
            const docTypes = this.getMissingDocTypes(records);
            const warning = docTypes.length
                ? this.$t('editTeamMember.equipmentDocsMissing', { unit: unitNo, docs: docTypes.join(', ') })
                : this.$t('editTeamMember.equipmentDocsMissingNoList', { unit: unitNo });
            // The modal renders raw HTML, so the alert is written out rather than using <b-alert>.
            if (appendToExisting) {
                return `<div class="alert alert-danger f-14 text-left mb-3" role="alert">${warning}</div>`;
            }
            return `<h3 class="f-18 mb-3">${warning}</h3> <p class="text-grey f-14 fw-400 mb-0">${this.$t('editTeamMember.equipmentDocsMissingConfirm')}</p>`;
        },
        async loadRequiredDocs() {
            try {
                const driverName = this.currentTeamMember.user
                    ? `${this.currentTeamMember.user.first_name} ${this.currentTeamMember.user.last_name}`
                    : this.currentTeamMember.name;
                if (!driverName) return;
                const url = `page=1&page_size=25&driver_id=${this.currentTeamMember.id}&required=True`;
                const requiredDocs = await this.getAllRequiredDocs(url);
                this.requiredDocsRecords = requiredDocs?.records || [];
            } catch (e) {
                console.log(e);
            }
        },
        async loadDriverCustomFields() {
            try {
                const list = await this.getCustomFields('driver');
                this.driverCustomFields = (list || [])
                    .filter(f => f.model === 'driver')
                    .slice()
                    .sort((a, b) => (a.order || 0) - (b.order || 0));
                this.applyCustomFieldValues();
            } catch (e) {
                console.log(e);
            }
        },
        applyCustomFieldValues() {
            const existing = (this.currentTeamMember && Array.isArray(this.currentTeamMember.custom_fields))
                ? this.currentTeamMember.custom_fields
                : [];
            const lookup = {};
            existing.forEach(entry => {
                const id = entry.id || entry.custom_field;
                if (id != null) lookup[id] = entry.value;
            });
            const next = {};
            this.driverCustomFields.forEach(f => {
                if (Object.prototype.hasOwnProperty.call(lookup, f.id)) {
                    next[f.id] = lookup[f.id];
                } else {
                    next[f.id] = f.field_type === 'multi_select' ? [] : null;
                }
            });
            this.customFieldValues = next;
            this.defaultCustomFieldValues = JSON.parse(JSON.stringify(next));
        },
        buildCustomFieldsWrite() {
            return this.driverCustomFields.map(f => {
                let v = this.customFieldValues[f.id];
                if (v === undefined || v === null) {
                    v = f.field_type === 'multi_select' ? [] : null;
                }
                return { id: f.id, value: v };
            });
        },
        getVehicleLabel() {
            const vehicleData = this.vehicleOptions.find((item) => item.id === this.defaultVehicle)
            return `${vehicleData?.label}`
        },
        isTrailerSelectable(option) {
            if (!this.isMultipleTrailers) return true
            if (this.selectedTrailerIds.length < this.getAllowedTrailers) return true
            return this.selectedTrailerIds.includes(option.id)
        },
        async goToVehicleDetail(id, label) {
            try {
                await this.updateTeamMemberData(false);
                const vehicleLabel = label.split(' | ')[0].trim();
                this.$router.push(`/equipment-list/vehicles?id=${id}&unitNo=${vehicleLabel}`);
            } catch (e) {
                console.log(e)
            }
        },
        async goToTrailerDetail(id, label) {
            try {
                await this.updateTeamMemberData(false);
                const trailerLabel = label.split(' | ')[0].trim();
                this.$router.push(`/equipment-list/trailers?id=${id}&unitNo=${trailerLabel}`);
            } catch (e) {
                console.log(e)
            }
        },
        async goToDriverDetail(id, label) {
            try {
                await this.updateTeamMemberData(false);
                this.$router.push(`/drivers?id=${id}&driver=${label}`);
            } catch (e) {
                console.log(e)
            }
        },
        verifyEquipmentStatus(status) {
            this.assignedEquipmentMessage = ""
            if (!status) {
                if (this.assignedExistingVehicle) this.defaultVehicle = null
                if (this.assignedExistingTrailer) {
                    this.defaultTrailer = this.isMultipleTrailers
                        ? this.selectedTrailerIds.filter((id) => id !== this.pendingTrailerId)
                        : null
                }
                this.assignedExistingVehicle = false
                this.assignedExistingTrailer = false
            }
            this.pendingTrailerId = null
        },
        async getVehicleData(e) {
            const vehicleData = this.vehicleOptions.find((item) => item.id === e)
            if (!vehicleData) return
            let message = ""
            if (vehicleData.status === 'Assigned' && vehicleData.driver_name) {
                message = `<h3 class="f-18 mb-3">${vehicleData.driver_name} is currently using this vehicle.</h3> <p class="text-grey f-14 fw-400 mb-0">Assigning this vehicle, will remove it from the other driver.
                        Are
                        you sure ?</p>`
                this.assignedExistingVehicle = true
            }
            const unitNo = this.getUnitNo(vehicleData.label)
            const missingDocs = await this.getEquipmentMissingDocs(unitNo, 'Vehicle')
            if (missingDocs.length) {
                message = this.buildMissingDocsMessage(unitNo, missingDocs, !!message) + message
                this.assignedExistingVehicle = true
            }
            this.assignedEquipmentMessage = message
        },
        async getTrailerData(e) {
            const selectedIds = Array.isArray(e) ? e : (e ? [e] : [])
            if (this.isMultipleTrailers && selectedIds.length > this.getAllowedTrailers) {
                this.defaultTrailer = selectedIds.slice(0, this.getAllowedTrailers)
                await this.setNotification({
                    msg: this.$t('editTeamMember.trailerLimitReached', { count: this.getAllowedTrailers }),
                    type: "error",
                    color: "red",
                });
                return
            }
            const trailerData = this.trailerOptions.find((item) => item.id === selectedIds[selectedIds.length - 1])
            if (!trailerData) return
            let message = ""
            if (trailerData.status === 'Assigned' && trailerData.driver_name) {
                this.pendingTrailerId = trailerData.id
                message = `<h3 class="f-18 mb-3">${trailerData.driver_name} is currently using this trailer.</h3> <p class="text-grey f-14 fw-400 mb-0">Assigning this trailer, will remove it from the other driver.
                        Are
                        you sure ?</p>`
                this.assignedExistingTrailer = true
            }
            const unitNo = this.getUnitNo(trailerData.label)
            const missingDocs = await this.getEquipmentMissingDocs(unitNo, 'Trailer')
            if (missingDocs.length) {
                this.pendingTrailerId = trailerData.id
                message = this.buildMissingDocsMessage(unitNo, missingDocs, !!message) + message
                this.assignedExistingTrailer = true
            }
            this.assignedEquipmentMessage = message
        },
        archiveDocumentItem(status) {
            if (status) {
                this.archiveDocument();
            }
            this.showArchiveDocumentModal = false;
        },
        async archiveDocument() {
            try {
                const data = this.items.filter(
                    (item) => this.itemId === item.pk
                )[0];
                await this.updateTeamMemberDocument({
                    id: data.pk,
                    payload: { ...data, is_archived: !this.unarchiveDocument, date: moment(data.date).format("YYYY-MM-DD"), expiry_date: data.expiry ? moment(data.expiry).format("YYYY-MM-DD") : null, object_id: this.currentTeamMember.id },
                });
                await this.setNotification({
                    msg: this.unarchiveDocument ? this.$t('editTeamMember.documentUnarchived') : this.$t('editTeamMember.documentArchived'),
                    type: "success",
                    color: "green",
                });
                await this.getTeamMember({ id: this.driverID, fetch_user: false });
                this.updateDocs();
                this.$emit("updateData", true);
            } catch (error) {
                await this.setNotification({
                    msg: error,
                    type: "error",
                    color: "red",
                });
            }
        },
        zoom(level) {
            if (!this.panzoom) {
                this.panzoom = Panzoom(document.getElementById('panzoom-element'), {
                    maxScale: 5
                })
            }
            level === -1 ? this.panzoom.zoomOut() : this.panzoom.zoomIn()
        },
        viewDriverMode() {
            window.open(`https://driver.digitalpermitbook.com/login?username=${this.memberUsername}&compid=${this.company[0].company_ID}&singleUse=true`, '_blank');
        },
        setDocDescription(event) {
            if (event) {
                this.documentData.description = this.getDotOptions.filter((option) => option.value === event)[0].text
            }
            else this.documentData.description = this.defaultDocsData.description
        },
        async downloadDoc(id, name) {
            this.setLoader(true)
            const doc = await this.retrieveDocument(id);
            fetch(doc.document)
                .then(response => {
                    if (!response.ok) {
                        throw new Error('Network response was not ok');
                    }
                    return response.blob();
                })
                .then(blob => {
                    const newUrl = window.URL.createObjectURL(blob);
                    const a = document.createElement('a');
                    a.style.display = 'none';
                    a.href = newUrl;
                    const urlWithoutParams = doc.document.split('?')[0];
                    const extension = urlWithoutParams.split('.').pop();
                    a.download = name + "." + extension
                    document.body.appendChild(a);
                    a.click();
                    window.URL.revokeObjectURL(newUrl);
                    a.remove()
                    this.setLoader(false)
                })
                .catch(error => {
                    this.setLoader(false)
                    console.log(error)
                });
        },
        async openDoc(id) {
            const doc = await this.retrieveDocument(id);
            this.media = doc.document
            this.mediaID = id
            this.itemId = id;
            if (doc.document.includes('.pdf')) this.mediaType = 'pdf'
            else this.mediaType = 'image'
        },
        async updateDriverStatus() {
            try {
                this.setLoader(true);
                await this.changeDriverStatus({
                    status: !this.currentTeamMember.status,
                    driver_ids: [this.currentTeamMember.id]
                })
                await this.setNotification({
                    msg: this.$t('editTeamMember.driverStatusUpdated', { status: this.currentTeamMember.status ? this.$t('editTeamMember.deactivated') : this.$t('editTeamMember.activated') }),
                    type: "success",
                    color: "green",
                });
                this.setLoader(false)
                this.$emit("updateData", true);
                this.$emit("resetDriver", true);
            }
            catch (e) {
                this.setLoader(false)
                console.log(e)
            }
        },
        async sentInvitetoDriver(password) {
            if (this.currentTeamMember.user.email && this.checkEmail(this.currentTeamMember.user.email)) {
                try {
                    this.setLoader(true)
                    await this.sendBulkInvite({
                        driver_ids: [this.currentTeamMember.id],
                        password: password ? password : null
                    });
                    await this.setNotification({
                        msg: this.$t('editTeamMember.invitationSent'),
                        type: "success",
                        color: "green",
                    });
                    this.setLoader(false)
                    this.$bvModal.hide('send-invite-modal')
                } catch (error) {
                    this.setLoader(false)
                    if (typeof error === "object") {
                        this.errors = error;
                        // eslint-disable-next-line no-ex-assign
                        error = "Couldnot send email";
                    }
                    await this.setNotification({
                        msg: error,
                        type: "error",
                        color: "red",
                    });
                }
            }
            else {
                await this.setNotification({
                    msg: 'Set Email First',
                    type: "error",
                    color: "red",
                });
            }
        },
        async setPass() {
            try {
                if (this.password) {
                    this.setLoader(true)
                    await this.setPasswordforAllDrivers({
                        driver_ids: [this.driverID],
                        password: this.password,
                    });
                    await this.setNotification({
                        msg: this.$t('editTeamMember.passwordSet'),
                        type: "success",
                        color: "green",
                    });
                    this.setLoader(false)
                    this.$bvModal.hide("modal-password");
                } else {
                    throw {
                        password: ["Please Enter Password."],
                    };
                }
            } catch (error) {
                this.setLoader(false)
                if (typeof error === "object") {
                    this.errors = error;
                    // eslint-disable-next-line no-ex-assign
                }
            }
        },
        async editDocument(id, docID) {
            this.editDocumentFlag = true;
            this.documentIndex = id;
            this.documentData = { ...this.currentTeamMember.docs[id], doc_type: this.currentTeamMember.docs[id].doc_type_id, date: moment.tz(this.currentTeamMember.docs[id].date, this.userTimeZone).toDate(), expiry_date: this.currentTeamMember.docs[id].expiry_date ? moment.tz(this.currentTeamMember.docs[id].expiry_date, this.userTimeZone).toDate() : "" };
            if (this.documentData.document) {
                let file_name = "";
                if (typeof this.documentData.document === "string") {
                    file_name = this.documentData.document;
                } else {
                    file_name = this.documentData.document.name;
                }
                this.fileName = file_name.substring(file_name.lastIndexOf("/") + 1);
            }
            this.errors = {
                date: null,
                type: null,
                document: null,
                expiry_date: "",
                description: null,
                ...this.company[0].doc_type ? { doc_type: null } : {}
            };
            await this.openDoc(docID)
            this.defaultDocsData = JSON.parse(JSON.stringify({ ...this.documentData, doc_type: this.currentTeamMember.docs[id].doc_type_id ? this.currentTeamMember.docs[id].doc_type_id : '' }))
            this.$bvModal.show("modal-document");
        },
        showPopup(id) {
            this.showDocumentModal = true;
            this.itemId = id;
        },
        showArchivePopup(id, isArchived = false) {
            this.showArchiveDocumentModal = true
            this.unarchiveDocument = isArchived;
            this.itemId = id;
        },
        sameAsDrivername() {
            if (this.currentTeamMember.is_dispatch_name) {
                if (this.driver.co_driver && this.driver.co_driver) {
                    this.currentTeamMember.dispatch_name = this.driver.co_driver.name
                } else {
                    this.currentTeamMember.dispatch_name =
                        this.currentTeamMember.user.first_name +
                        " " +
                        this.currentTeamMember.user.last_name;
                }
            }
        },
        closePopup() {
            this.$emit("resetDriver", true);
        },
        addDocument() {
            this.fileName = null;
            this.editDocumentFlag = false;
            this.$bvModal.show("modal-document");
            this.documentData = {
                object_id: null,
                date: new Date(),
                type: null,
                document: null,
                expiry_date: "",
                description: null,
                driver: true,
                dot_mode: true,
                doc_type: ""
            };
            this.defaultDocsData = JSON.parse(JSON.stringify(this.documentData))
            this.errors = {
                date: null,
                type: null,
                document: null,
                expiry_date: "",
                description: null,
                ...this.company[0].doc_type ? { doc_type: null } : {}
            };
        },
        resetField() {
            if (this.$refs.docFile) this.$refs.docFile.value = null;
        },
        async generateDriverQRCode(password) {
            this.qrCodeValue = `https://driver.digitalpermitbook.com/login?username=${this.memberUsername}&compid=${this.company[0].company_ID}${password ? `&password=${password}` : ''}`;
            await this.$nextTick();
            this.qrCodeUrl =
                this.$refs?.qrcode.qrious._canvasRenderer.element.toDataURL();
            generateQRCode(`${this.currentTeamMember.user.first_name} ${this.currentTeamMember.user.last_name}`, this.currentTeamMember.id, `${this.currentTeamMember.user.first_name} ${this.currentTeamMember.user.last_name}-qrcode`, this.qrCodeUrl)
            this.$bvModal.hide("qr-password-modal");
        },
        addTag() {
            this.showTagsModal = false;
        },
        removeFile() {
            this.fileName = null;
            // this.$refs.docFile.value = "";
            this.documentData.document = null
            this.media = null
            this.mediaType = null
        },
        async searchVehicle(searchText) {
            if (searchText) {
                const records = await this.getFilteredEquipments({ unit_no: searchText, type: "Vehicle", status: 'Active,Assigned' });
                this.typeOptions(records)
            }
        },
        async searchTrailer(searchText) {
            if (searchText) {
                const records = await this.getFilteredEquipments({ unit_no: searchText, type: "Trailer", status: 'Active,Assigned' });
                this.subTypeOptions(records)
            }
        },
        typeOptions(records) {
            let options = [];

            // Add default vehicle only if not already in records
            const defaultVehicle = this.currentTeamMember.default_vehicle;
            if (
                defaultVehicle &&
                !records.some((x) => x.id === defaultVehicle.id)
            ) {
                options.push({
                    id: defaultVehicle.id,
                    label: `${defaultVehicle.unit_no} | ${defaultVehicle.division_name}`,
                });
            }

            // Add all from records
            records.forEach((x) => {
                options.push({
                    id: x.id,
                    label: `${x.unit_no} | ${x.division_name}`,
                    status: x.status,
                    driver_id: x.driver_id,
                    driver_name: x.driver_name,
                    division_name: x.division_name
                });
            });

            // Merge and deduplicate by `id`
            this.vehicleOptions = [
                ...new Map(
                    [...this.vehicleOptions, ...options].map(item => [item.id, item])
                ).values()
            ];

        },
        subTypeOptions(records) {
            let options = [];

            const defaultTrailer = this.currentTeamMember.default_trailer;

            // Add default trailer if it exists and is not already in the records
            if (
                defaultTrailer &&
                !records.some((x) => x.id === defaultTrailer.id)
            ) {
                options.push({
                    id: defaultTrailer.id,
                    label: `${defaultTrailer.unit_no} | ${defaultTrailer.division_name}`
                });
            }

            // Add all trailers from records
            records.forEach((x) => {
                options.push({
                    id: x.id,
                    label: `${x.unit_no} | ${x.division_name}`,
                    status: x.status,
                    driver_id: x.driver_id,
                    driver_name: x.driver_name,
                    division_name: x.division_name
                });
            });

            // Merge with existing and deduplicate by ID
            this.trailerOptions = [
                ...new Map(
                    [...this.trailerOptions, ...options].map(item => [item.id, item])
                ).values()
            ];

        },
        async searchDriver(searchText) {
            if (searchText) {
                const driverRecords = await this.getFilteredDrivers(searchText);
                this.coDrivers = []
                driverRecords
                    .filter(
                        (driver) =>
                            !driver.co_driver
                    )
                    .map((item) => {
                        this.coDrivers.push({
                            id: item.id,
                            label: item.name,
                        });
                    });
            }
        },
        async updateTeamMemberData(closePopup = true, showNotification = true) {
            try {
                if (!this.memberUsername) {
                    await this.setNotification({
                        msg: this.$t('editTeamMember.usernameRequired'),
                        type: "error",
                        color: "red",
                    });
                    return;
                }
                if (this.memberUsername && this.memberUsername.length < 4) {
                    await this.setNotification({
                        msg: this.$t('editTeamMember.usernameMinLength'),
                        type: "error",
                        color: "red",
                    });
                    return;
                }
                if (this.memberUsername && this.memberUsername.includes(`.${this.company[0].company_ID}`)) {
                    await this.setNotification({
                        msg: this.$t('teamMemberShared.usernameNoCompId'),
                        type: "error",
                        color: "red",
                    });
                    return;
                }
                if (this.currentTeamMember.user.email) {
                    if (!this.checkEmail(this.currentTeamMember.user.email)) {
                        throw {
                            email: [this.$t('teamMemberShared.wrongFormat')],
                        };
                    }
                }
                if (this.memberUsername && (this.memberUsername.includes("@") || this.memberUsername.includes(" "))) {
                    await this.setNotification({
                        msg: this.$t('teamMemberShared.usernameNoSpecialChars'),
                        type: "error",
                        color: "red",
                    });
                    return;
                }
                if (this.currentTeamMember.phone) {
                    if (!this.checkPhoneFormat(this.driverPhoneNumber)) {
                        throw {
                            phone: [this.$t('teamMemberShared.wrongFormat')],
                        };
                    }
                }

                if (
                    this.currentTeamMember.role === "Driver" &&
                    this.currentTeamMember.pin_code
                ) {
                    if (this.currentTeamMember.pin_code.length > 4) {
                        await this.setNotification({
                            msg: this.$t('editTeamMember.maxFourDigits'),
                            type: "error",
                            color: "red",
                        });
                        return;
                    } else if (areAllDigitsSame(this.currentTeamMember.pin_code)) {
                        await this.setNotification({
                            msg: this.$t('editTeamMember.digitsNotSame'),
                            type: "error",
                            color: "red",
                        });
                        return;
                    } else this.membersPinCode = this.currentTeamMember.pin_code;
                }
                if (closePopup) this.setLoader(true)
                const nullKeys = this.checkNullValues({
                    first_name: this.currentTeamMember.user.first_name,
                    last_name: this.currentTeamMember.user.last_name,
                    username: this.currentTeamMember.user.username,
                });
                if (nullKeys.length === 0) {
                    delete this.currentTeamMember.profile_picture;
                    delete this.currentTeamMember.user.password;
                    this.currentTeamMember.default_vehicle = this.defaultVehicle;
                    this.currentTeamMember.name = this.currentTeamMember.user.first_name + " " + this.currentTeamMember.user.last_name
                    if (this.selectedTrailerIds.length) this.currentTeamMember.assigned_trailers = [...this.selectedTrailerIds];
                    else {
                        this.currentTeamMember.assigned_trailers = [];
                        this.currentTeamMember.default_trailer = null;
                    }
                    this.currentTeamMember.status = this.userActiveStatus
                    this.currentTeamMember.user.username =
                        this.memberUsername + "." + this.company[0].company_ID;
                    let currentMember = {
                        ...this.currentTeamMember,
                        state: this.currentTeamMember.state.id
                            ? this.currentTeamMember.state.id
                            : 54,
                        license_state: this.currentTeamMember.license_state.id
                            ? this.currentTeamMember.license_state.id
                            : 54,
                        division: this.currentTeamMember.division.id,
                        dispatch_name:
                            this.currentTeamMember.is_dispatch_name && this.driver.co_driver
                                ? this.driver.co_driver.name
                                : this.currentTeamMember.dispatch_name,
                        dispatch_group1: this.dispatch_group1,
                        dispatch_group2: this.dispatch_group2,
                        co_driver: this.driver.co_driver,
                        activate_date: this.currentTeamMember.activate_date ? moment(this.currentTeamMember.activate_date).format("YYYY-MM-DD") : null,
                        clearing_house_date: this.currentTeamMember.clearing_house_date
                            ? this.currentTeamMember.clearing_house_date
                            : null,
                        dob: this.currentTeamMember.dob ? moment(this.currentTeamMember.dob).format("YYYY-MM-DD") : null,
                        inactive_date: this.currentTeamMember.inactive_date ? moment(this.currentTeamMember.inactive_date).format("YYYY-MM-DD") : null,
                        pre_emp_drug_test_date: this.currentTeamMember.pre_emp_drug_test_date
                            ? this.currentTeamMember.pre_emp_drug_test_date
                            : null,
                        pre_emp_mvr_date: this.currentTeamMember.pre_emp_mvr_date
                            ? this.currentTeamMember.pre_emp_mvr_date
                            : null,
                        pre_emp_clearing_house_date: this.currentTeamMember
                            .pre_emp_clearing_house_date
                            ? this.currentTeamMember.pre_emp_clearing_house_date
                            : null,
                        hazmat_date: this.currentTeamMember.hazmat_date
                            ? this.currentTeamMember.hazmat_date
                            : null,
                        insurance_date: this.currentTeamMember.insurance_date
                            ? this.currentTeamMember.insurance_date
                            : null,
                        license_date: this.currentTeamMember.license_date
                            ? this.currentTeamMember.license_date
                            : null,
                        medical_card_date: this.currentTeamMember.medical_card_date
                            ? this.currentTeamMember.medical_card_date
                            : null,
                        mvr_review_date: this.currentTeamMember.mvr_review_date
                            ? this.currentTeamMember.mvr_review_date
                            : null,
                        other_date: this.currentTeamMember.other_date
                            ? this.currentTeamMember.other_date
                            : null,
                        twic_card_date: this.currentTeamMember.twic_card_date
                            ? this.currentTeamMember.twic_card_date
                            : null,
                        lock_trailer: this.currentTeamMember.lock_trailer ? true : false,
                        phone: this.currentTeamMember.phone ? !this.currentTeamMember.phone.includes("+1") ? "+1 " + this.currentTeamMember.phone : this.currentTeamMember.phone : ''
                    };
                    this.currentTeamMember.years_of_experience =
                        this.currentTeamMember.years_of_experience !== ""
                            ? this.currentTeamMember.years_of_experience
                            : null;
                    delete currentMember.default_trailer;
                    const updatedTeamMember = await this.updateTeamMember({
                        id: this.driverID,
                        payload: {
                            ...currentMember,
                            tags: this.existingTags.length
                                ? this.existingTags
                                : [],
                            vehicle_assignment_tags: this.vehicleTags.length && !this.currentTeamMember.lock_vehicle
                                ? this.vehicleTags
                                : [],
                            trailer_assignment_tags: this.trailerTags.length && !this.currentTeamMember.lock_trailer
                                ? this.trailerTags
                                : [],
                            custom_fields_write: this.buildCustomFieldsWrite(),
                        }
                    });

                    if (this.currentTeamMember) {
                        if (showNotification) {
                            await this.setNotification({
                                msg: this.$t('editTeamMember.memberUpdated', { name: `${this.currentTeamMember.user.first_name} ${this.currentTeamMember.user.last_name}` }),
                                type: "success",
                                color: "green",
                            });
                        }
                        if (closePopup) {
                            this.$emit("updateDriver", updatedTeamMember);
                            this.$emit("resetDriver", true);
                        }
                        else this.$emit("updateData", true);
                        if (showNotification) this.setLoader(false)
                    }
                }
                else {
                    this.setLoader(false);
                    let error = {};
                    nullKeys.forEach((x) => {
                        if (x === 'password' && this.newTeamMember.password && this.newTeamMember.password.length < 4) error['password'] = [this.$t('teamMemberShared.passwordMinLength')]
                        else error[x] = [this.$t('teamMemberShared.fieldRequired')];
                    });
                    throw error;
                }
            } catch (error) {
                this.setLoader(false)
                if (Array.isArray(error)) {
                    await this.setNotification({
                        msg: error[0],
                        type: "error",
                        color: "red",
                    });
                }
                if (typeof error === "object" && error.error) {
                    await this.setNotification({
                        msg: Array.isArray(error.error) ? error.error[0] : error.error,
                        type: "error",
                        color: "red",
                    });
                }
                else if (typeof error === "object") {
                    this.errors = error;
                    // eslint-disable-next-line no-ex-assign
                }
                else {
                    await this.setNotification({
                        msg: error,
                        type: "error",
                        color: "red",
                    })
                }
            }
        },
        deleteDocumentItem(item) {
            if (item) {
                this.deleteDocument(this.itemId);
            }
            this.showDocumentModal = false;
        },
        deleteDriverItem(item) {
            if (item) {
                this.deleteDriver();
            }
            this.showDeleteDriverModal = false;
        },
        async deleteDocument(id) {
            try {
                this.setLoader(true)
                await this.deleteCompanyDocument(`${id}/?company_id=${this.userCompany}`);
                await this.getTeamMember({ id: this.driverID, fetch_user: false });
                this.updateDocs();
                this.itemId = null
                await this.setNotification({
                    msg: this.$t('editTeamMember.documentDeleted'),
                    type: "success",
                    color: "green",
                });
                this.defaultData = JSON.parse(JSON.stringify({ ...this.currentTeamMember, driverPhoneNumber: this.currentTeamMember.phone ? this.currentTeamMember.phone.startsWith("+1") ? this.currentTeamMember.phone.slice(2).trim() : this.currentTeamMember.phone : '' }))
                this.setLoader(false)
                this.$bvModal.hide("modal-document");
                this.$emit("updateData", true);
            } catch (error) {
                this.setLoader(false)
                await this.setNotification({
                    msg: error,
                    type: "error",
                    color: "red",
                });
            }
        },
        changeDriverStatusItem(item) {
            if (item) {
                this.updateDriverStatus();
            }
            this.showMemberModal = false;
        },
        async deleteDriver() {
            try {
                this.setLoader(true)
                await this.deleteTeamMember(`${this.currentTeamMember.id}/?company_id=${this.userCompany}`);
                await this.setNotification({
                    msg: this.$t('editTeamMember.driverDeleted'),
                    type: "success",
                    color: "green",
                });
                this.setLoader(false)
                this.$emit("updateData", true);
                this.$emit("resetDriver", true);
            } catch (error) {
                this.setLoader(false)
                await this.setNotification({
                    msg: error,
                    type: "error",
                    color: "red",
                });
            }
        },
        handleFileUpload() {
            this.documentData.document = this.$refs.docFile.files[0];
            this.fileName = this.documentData.document.name;
            this.media = URL.createObjectURL(this.documentData.document);
            if (this.$refs.docFile.files[0].type.includes('pdf')) this.mediaType = 'pdf'
            else this.mediaType = 'image'
        },
        updateDocs() {
            this.items = [];
            this.currentTeamMember.docs.sort((a, b) => a.description?.toLowerCase().localeCompare(b.description?.toLowerCase())).forEach((doc, id) => {
                let color;
                if (doc.expiry_date) {
                    const currentDate = new Date();
                    const expiryDate = new Date(doc.expiry_date);
                    const diffDays = parseInt(
                        (expiryDate - currentDate) / (1000 * 60 * 60 * 24),
                        10
                    );
                    if (diffDays > 30) {
                        color = "color:black";
                    } else if (diffDays <= 30 && diffDays >= 1) {
                        color = "color:#FFC800";
                    } else color = "color:#FF0000";
                }
                this.items.push({
                    id: id,
                    pk: doc.id,
                    Date: moment(doc.date).format("ll"),
                    Description: doc.description,
                    Driver: doc.driver,
                    dot_mode: doc.dot_mode,
                    link: doc.document,
                    expiry_date: doc.expiry_date
                        ? `<span style=${color}>${moment(doc.expiry_date).format(
                            "LL"
                        )}</span>`
                        : "-",
                    name: `${this.currentTeamMember.user.first_name} ${this.currentTeamMember.user.last_name}-${doc.description ? doc.description : ''}`,
                    expiry: doc.expiry_date,
                    is_archived: doc.is_archived
                });
                if (this.items.length === 0) this.emptyTable = true
                else this.emptyTable = false
            });
        },
        async updateDocumentOnToggle(id, key, value) {
            try {
                this.setLoader(true)
                this.currentTeamMember.docs[id][key] = value;
                if (!this.currentTeamMember.docs[id].expiry_date)
                    delete this.currentTeamMember.docs[id].expiry_date;
                delete this.currentTeamMember.docs[id].document;
                await this.updateTeamMemberDocument({
                    id: this.currentTeamMember.docs[id].id,
                    payload: this.currentTeamMember.docs[id],
                });
                await this.setNotification({
                    msg: this.$t('editTeamMember.documentUpdated'),
                    type: "success",
                    color: "green",
                });
                this.setLoader(false)
            } catch (error) {
                this.setLoader(false)
                await this.setNotification({
                    msg: error,
                    type: "error",
                    color: "red",
                });
            }
        },
        checkNullValues(payload) {
            let nullKeys = [];
            for (let [key, value] of Object.entries(payload)) {
                if (!value) {
                    nullKeys.push(key);
                }
            }
            return nullKeys;
        },
        extractFilePath(url) {
            const pathname = new URL(url).pathname;

            return pathname.substring(pathname.indexOf("documents/"));
        },
        async sendDocumentData() {
            try {
                if (this.documentData.description && this.checkDescriptionLength(this.documentData.description)) {
                    throw {
                        description: [this.$t('editTeamMember.descriptionMaxLength')],
                    };
                }
                const nullKeys = this.checkNullValues({
                    date: this.documentData.date,
                    document: this.documentData.document,
                    ...this.company[0].doc_type ? { doc_type: this.documentData.doc_type } : {},
                    ...this.company[0].is_division_required ? { division: this.currentTeamMember.division } : {}
                });
                if (nullKeys.length === 0) {
                    this.setLoader(true);
                    let formData = new FormData();
                    let fileType = this.documentData.document instanceof File || this.documentData.document instanceof Blob;
                    if (!fileType) this.documentData.document = null
                    formData.append("object_id", this.currentTeamMember.id);
                    formData.append(
                        "date",
                        moment(this.documentData.date).format("YYYY-MM-DD")
                    );
                    formData.append("type", this.documentData.type);
                    formData.append("description", this.documentData.description);
                    if (this.documentData.doc_type) formData.append("doc_type", this.documentData.doc_type);
                    if (this.documentData.document) {
                        formData.append(
                            "document",
                            new File(
                                [this.documentData.document],
                                this.currentTeamMember.user.first_name + "_" + this.currentTeamMember.user.last_name + "_" + this.documentData.description +
                                "_" + this.userCompany + "_" +
                                new Date().getTime() +
                                "." +
                                this.documentData.document["type"].split("/").pop(),
                                { type: this.documentData.document["type"] }
                            )
                        );
                    }
                    formData.append("expiry_date", this.documentData.expiry_date ? moment(this.documentData.expiry_date).format("YYYY-MM-DD") : '');
                    formData.append("driver", this.documentData.driver);
                    formData.append("dot_mode", this.documentData.dot_mode);
                    formData.append("model_type", "teammember");
                    formData.append("company_id", parseInt(localStorage.getItem("userSelectedCompany")));
                    if (this.editDocumentFlag) {
                        this.documentData = await this.updateTeamMemberDocument({
                            id: this.documentData.id,
                            payload: formData,
                        });
                        await this.setNotification({
                            msg: this.$t('editTeamMember.documentUpdatedToast'),
                            type: "success",
                            color: "green",
                        });
                        let color;
                        if (this.documentData.expiry_date) {
                            const currentDate = new Date();
                            const expiryDate = new Date(this.documentData.expiry_date);
                            const diffDays = parseInt(
                                (expiryDate - currentDate) / (1000 * 60 * 60 * 24),
                                10
                            );
                            if (diffDays > 30) {
                                color = "color:black";
                            } else if (diffDays <= 30 && diffDays >= 1) {
                                color = "color:#FFC800";
                            } else color = "color:#FF0000";
                        }
                        this.currentTeamMember.docs[this.documentIndex] = { ...this.documentData, doc_type_id: this.documentData.doc_type, document: this.extractFilePath(this.documentData.document) };
                        this.items[this.documentIndex].Date = moment(
                            this.documentData.date
                        ).format("ll");
                        this.items[this.documentIndex].Type = this.documentData.type;
                        this.items[this.documentIndex].Description =
                            this.documentData.description;
                        this.items[this.documentIndex].expiry_date = this.documentData
                            .expiry_date
                            ? `<span style=${color}>${moment(
                                this.documentData.expiry_date
                            ).format("ll")}</span`
                            : "-";
                        this.items[this.documentIndex].Driver = this.documentData.driver;
                        this.editDocumentFlag = false;
                        this.updateDocs();
                        this.documentData = {
                            object_id: null,
                            date: null,
                            type: null,
                            expiry_date: "",
                            document: null,
                            description: null,
                            driver: true,
                            dot_mode: true,
                            doc_type: ""
                        };
                        this.fileName = null;
                        this.$emit("updateData", true);
                        this.$bvModal.hide("modal-document");
                    } else {
                        if (this.documentData.date) {
                            await this.sendTeamMemberDocument(formData);
                            await this.getTeamMember({ id: this.driverID, fetch_user: false });
                            this.defaultData = JSON.parse(JSON.stringify({ ...this.currentTeamMember, driverPhoneNumber: this.currentTeamMember.phone ? this.currentTeamMember.phone.startsWith("+1") ? this.currentTeamMember.phone.slice(2).trim() : this.currentTeamMember.phone : '' }))
                            this.updateDocs();
                            await this.setNotification({
                                msg: this.editDocumentFlag ? this.$t('editTeamMember.documentUpdatedToast') : this.$t('editTeamMember.documentAdded'),
                                type: "success",
                                color: "green",
                            });
                            this.documentData = {
                                object_id: null,
                                date: null,
                                type: null,
                                expiry_date: "",
                                document: null,
                                description: null,
                                driver: true,
                                dot_mode: true,
                                doc_type: ""
                            };
                            this.fileName = null;
                            this.$emit("updateData", true);
                            this.$bvModal.hide("modal-document");
                        }
                    }
                    this.setLoader(false);
                }
                else {
                    let error = {};
                    nullKeys.forEach((x) => {
                        error[x] = [this.$t('teamMemberShared.fieldRequired')];
                    });
                    throw error;
                }
            } catch (error) {
                this.setLoader(false);
                if (typeof error === "object") {
                    this.errors = error;
                    // eslint-disable-next-line no-ex-assign
                }
            }
        },
    },
}
</script>

<style>
.required-docs-banner {
    background-color: #FDE8E8;
    border: 1px solid #F5C2C2;
    border-radius: 8px;
    padding: 10px 14px;
    color: #FF0000;
}

.document-cards-list {
    display: flex;
    flex-direction: column;
    gap: 8px;
}

.document-card {
    background: #FFFFFF;
    border: 1px solid #E2E6F0;
    border-radius: 5px;
    padding: 12px;
    display: flex;
    flex-direction: column;
    gap: 8px;
}

.document-card-empty {
    border: 1px solid #E2E6F0;
}

.document-card-top {
    display: flex;
    align-items: center;
    justify-content: space-between;
    gap: 8px;
    width: 100%;
}

.document-card-title {
    font-family: 'Poppins', sans-serif;
    font-weight: 500;
    font-size: 16px;
    line-height: 24px;
    letter-spacing: -0.5px;
    color: #222736;
    word-break: break-word;
    text-align: left;
    flex: 1 1 auto;
    min-width: 0;
}

.document-card-date {
    font-family: 'Poppins', sans-serif;
    font-weight: 400;
    font-size: 14px;
    line-height: 24px;
    letter-spacing: -0.32px;
    color: black;
    white-space: nowrap;
}

.document-card-date.is-expired {
    color: #FF0000;
}

.document-card-divider {
    height: 1px;
    width: 100%;
    background: #E2E6F0;
}

.document-card-bottom {
    display: flex;
    align-items: center;
    justify-content: space-between;
    gap: 16px;
    width: 100%;
    flex-wrap: wrap;
}

.document-card-switches {
    display: flex;
    align-items: center;
    gap: 20px;
    flex-wrap: wrap;
}

.document-card-label {
    font-family: 'Poppins', sans-serif;
    font-weight: 400;
    font-size: 14px;
    line-height: 24px;
    letter-spacing: -0.32px;
    color: #8290AC;
}

.document-card-actions {
    display: flex;
    align-items: center;
    gap: 8px;
}

.document-card-icon {
    cursor: pointer;
    flex-shrink: 0;
}

.document-card-icon:hover {
    opacity: 0.7;
}

.info-card-meta {
    display: flex;
    flex-wrap: wrap;
    gap: 8px 24px;
    width: 100%;
}

.info-card-stat {
    font-family: 'Poppins', sans-serif;
    font-weight: 400;
    font-size: 14px;
    line-height: 22px;
    letter-spacing: -0.32px;
    color: #8290AC;
}

.info-card-stat strong {
    color: #222736;
    font-weight: 500;
}

.info-card-amount {
    font-family: 'Poppins', sans-serif;
    font-weight: 500;
    font-size: 16px;
    line-height: 24px;
    letter-spacing: -0.5px;
    color: #222736;
}

.info-card-total {
    display: flex;
    align-items: center;
    justify-content: space-between;
    margin-top: 12px;
    padding: 12px;
    background: #F8F8FA;
    border: 1px solid #E2E6F0;
    border-radius: 8px;
}

.info-card-total-label {
    font-family: 'Poppins', sans-serif;
    font-weight: 500;
    font-size: 14px;
    line-height: 24px;
    letter-spacing: -0.32px;
    color: #8290AC;
    text-transform: uppercase;
}

.info-card-total-value {
    font-family: 'Poppins', sans-serif;
    font-weight: 600;
    font-size: 16px;
    line-height: 24px;
    letter-spacing: -0.5px;
    color: #222736;
}

.lock-toggle-col {
    min-width: 110px;
}</style>